import {http} from './index';

//查询Q&A列表
export const getCommonQuestionList = (params:any) => http.post('/teaching-workbench/common/question/find/operate/asks', params);

//我要提问
export const addCommonQuestion = (params: any) => http.post('/teaching-workbench/common/question/add/operate/ask', params);
